import { getHelpNodesBySlug } from '$lib/help'

export const load = () => {
  const popularPosts = getHelpNodesBySlug([
    'what-is-a-session',
    'movements',
    'outfits-and-poses',
    'pausly-for-organizations',
  ])

  return { popularPosts }
}
